// JavaScript Document
//components/signs/class/Form.js
import React from 'react';
//import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
//import AppBar from '@material-ui/core/AppBar';
import Typography from '@material-ui/core/Typography';
//import {flexbox} from '@material-ui/system';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
//import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import SaveIcon from '@material-ui/icons/Save';
import ImagePicker from '../forms/ImagePicker';
import DeleteButton from '../../core/DeleteButton';
//import TextArea from '@material-ui/core/TextareaAutosize';
//import Display from '../../display/Display';
//import Paper from '@material-ui/core/Paper';

const useStyles = makeStyles((theme) => ({
	advancedCard : {
		margin: theme.spacing(1),
		display: "flex",
		flexDirection:"column",
		alignItems:"stretch",
		justifyContent:"center",
		flexWrap:"wrap"
	},
	advancedContent : {
		display: "flex",
		flexGrow: 1,
		alignItems: "center",
		justifyContent: "space-around",
		flexWrap: "wrap"
	},
	detailsVerticalCenter: {
		display: "flex",
		alignItems:"center",
		justifyContent:"space-around",
		flexGrow: 1,
		flexDirection: "column",
		flexWrap: "wrap",
	},
	sizeInput : {
		minWidth: 15,
		maxWidth: 100,
	},

	timingInput : {
		margin: theme.spacing(1),
		width: 90
	},
  maxDisplayGrid: {
	  minHeight: 300
  }
}));

export default function SignClassForm(props) {
  	const classes = useStyles();
	//inherited variables
  	const {handleSend, item, pics, onChange} = props;
	//locally stored/copied variables
	const [isNew, setIsNew] = React.useState(false);
	const [changed, setChanged] = React.useState(false);
	const [saveLabel, setSaveLabel] = React.useState('Save');
	const [details, setDetails] = React.useState({
		id: '',
		name: '',
		description: '',
		pic: '',
		type: 'sign_class',
		opt_width: 0,
		opt_height: 0
	});
	const codes = [
		'Ph4',
		'Ph5',
		'Ph5R',
		'Ph6L',
		'Ph6',
		'RRFB'
	];
	
	//Refresh UI on props change
	React.useEffect(() => {
		if(!item.id){
			setIsNew(true);
		} else {
			setIsNew(false);
		}
		if(
			item.id 
			&& item.id !== details.id
		) {
			//console.log('config has changed');
			setDetails(item);
			
		}
	}, [details.id, item]);
	
	//Final delete clicked
	const handleDelete = () => {
		setIsNew(true);
		console.log('Deleted!');
		handleSend({
			vso: 'option',
			option: details,
			subaction: 'delete'
		}, (data) => {
			setIsNew(false);
			setChanged(false);
			if(onChange){
				onChange(false);
			}
		})
	}
	
	
	//render card actions (save & Delete)
	const cardActions = () => {
		return (
			<ButtonGroup>
				{saveButton()}
				<DeleteButton onClick={handleDelete} visible={!isNew} />
			</ButtonGroup>
		)
	}
	
	
	//handle change any value
	const handleChangeValue = (e) => {
		let name = e.target.name;
		let value = e.target.value
		let newDetails = Object.assign({}, details);
		
		//if numeric
		if([
			'opt_height', 
			'opt_width'
		   ].indexOf(name) !== -1){
			value = parseInt(value);
			//clean the value
			if(isNaN(value) || value < 0){
				value = 0;
			} else if(value > 99){
				value = 99;
			}
		}
		
		newDetails[name] = value;
		setDetails(newDetails);
		setChanged(true);
	}
	
	//Handle save buttonclick
	const handleSave = (e) => {
		setSaveLabel('Saving');
		console.log("Save button clicked!");
		handleSend({
			vso: 'option',
			option: details,
			subaction: 'save'
		}, (data) => {
			console.log(data);
			setChanged(false);
			setSaveLabel('Save');
			//setConfig(data.config);
			setDetails(data.option);
			//update parent if onChange is supplied
			if(onChange){
				onChange(data.option, isNew);
			}
			setIsNew(false);
			
		});
	}
	//Handle update parent if onChange is provided
	/*
	const handleUpdateParent = (newTiming, newDim, newAlternate) => {
		if(onChange){
			console.log('Updating parent');
			onChange([newTiming.wigOn, newTiming.wigOff, newTiming.wagOn, newTiming.wagOff], newDim, newAlternate);
		}
	}
	*/
	const saveButton = () => {
		if(changed){
			return (
				<Button 
					variant="contained" 
					color="primary" 
					onClick={handleSave} 
					endIcon={<SaveIcon />}
					disabled={saveLabel==='Saving' ? true : false}
				>
					{saveLabel}
				</Button>
			);
		}
		return '';
	}
	
  	//standard size: 
	//1 panel = 6 x 9 x 2 rows = 30 x 18

  	return (
    	<Card className={classes.advancedCard}>
			<CardHeader title={isNew ? 'New Sign Class' : details.name} action={cardActions()}/>
	  		<CardContent>
				<Grid container spacing={3}>
					<Grid item xs={12} sm={4}>
					<TextField
						id="class_name"
						name="name"
						label="Name"
						required
						value={details.name}
						type="text"
						inputProps = {{
									  maxlength:"25"
									 }}
						onChange={handleChangeValue}
						fullWidth
					/>
					
					<TextField
						id="class_description"
						name="description"
						label="Description"
						multiline
						maxRows={4}
						value={details.description}
						onChange={handleChangeValue}
						fullWidth
					/>
				</Grid>
				<Grid item xs={12} sm={4}>
					<TextField
						id="class_code"
						name="cfg_reference"
						label="Code"
						value={details.cfg_reference ?? ' '}
						select
						required
						onChange={handleChangeValue}
						fullWidth
					>
						{codes.map((row, i) => (
						<MenuItem value={row} key={i}>{row}</MenuItem>
						))}
					</TextField>
					<Typography>Panel Size</Typography>
					<Grid container spacing={3}>
						<Grid item xs={12} sm={6}>
							<TextField
								id="panel_width"
								name="opt_width"
								label="Width"
								type="number"
								value={details.opt_width.toString()}
								onChange={handleChangeValue}
								inputProps={{min:'0', max:'99', style:{textAlign:'center'}}}
								fullWidth
							/>
						</Grid>
						<Grid item xs={12} sm={6}>
							<TextField
								id="panel_height"
								name="opt_height"
								label="Height"
								type="number"
								value={details.opt_height.toString()}
								onChange={handleChangeValue}
								inputProps={{min:'0', max:'99', style:{textAlign:'center'}}}
								fullWidth
							/>
						</Grid>
					</Grid>
				</Grid>
				<Grid item xs={12} sm={4}>
					<ImagePicker
						id="class_pic"
						label="Image"
						name="pic"
						value={details.pic}
						items={pics}
						onChange={handleChangeValue}
						select
					/>
				</Grid>
			</Grid>
	  		</CardContent>
	  	</Card>
  );
}
